import dayjs from 'dayjs'

import { dayStringMonthYearHourMinutesFormat } from 'src/libs'
import { useLocales } from 'src/locales'

import 'dayjs/locale/ro'
import 'dayjs/locale/ru'

export const useNotificationsFormat = () => {
  const { t, currentLang } = useLocales()

  const getTimeDifference = (date: string) => {
    const parsedDate = dayjs.utc(date)

    const isToday = dayjs(parsedDate).isToday()

    if (isToday) {
      const minutesDifference = dayjs().diff(parsedDate, 'minute')
      const hourDifference = Math.floor(minutesDifference / 60)

      if (!minutesDifference) {
        return t('notifications.now')
      }

      if (!hourDifference) {
        return `${minutesDifference} ${t(
          `notifications.${minutesDifference === 1 ? 'minute' : 'minutes'}`
        )}  ${t('notifications.ago')}`
      }

      return `${hourDifference} ${t(
        `notifications.${hourDifference === 1 ? 'hour' : 'hours'}`
      )}  ${t('notifications.ago')}`
    }

    return `${dayjs
      .tz(parsedDate)
      .locale(currentLang.value)
      .format(dayStringMonthYearHourMinutesFormat)}`
  }

  return { getTimeDifference }
}
